// Fatia S1: planos (GET /plans) separados entre negócios e agências. Visual da home (home.css).
import { useState } from 'react'
import { ShieldCheck } from 'lucide-react'
import { Tabs, ErrorState, Loading } from '../../ui'
import { usePlans } from '../../features/billing/api'
import { Faq, FinalCta, LeadForm, PlanCard, Section } from '../../features/public/Site'
import { Reveal, Words } from '../../features/public/motion'

export default function Pricing() {
  const plans = usePlans()
  const [kind, setKind] = useState<'business' | 'agency'>('business')
  const list = (plans.data ?? []).filter((p) => p.kind === kind)
  return (
    <div className="sh">
      <Section hero>
        <Words as="h1" immediate className="sh-display sh-h1" text="Preços simples, *sem fidelidade.*" />
        <Reveal as="p" delay={300} className="sh-lead">Você paga a assinatura do Seu Impulso. O dinheiro dos anúncios vai direto para as plataformas, do jeito que já é hoje.</Reveal>
        <div className="sh-hero-tabs"><Tabs value={kind} onChange={setKind} options={[{ value: 'business', label: 'Para o seu negócio' }, { value: 'agency', label: 'Para agências' }]} /></div>
        <div className="sh-plans sh-grid3">
          {list.map((p) => <PlanCard key={p.id} plan={p} highlight={p.id === 'crescimento' || p.id === 'agencia_pro'} />)}
        </div>
        {plans.isLoading && <div className="mt-24"><Loading /></div>}
        {plans.error && <div className="mt-24"><ErrorState error={plans.error} onRetry={() => plans.refetch()} /></div>}
        <p className="sh-fine">
          {kind === 'agency'
            ? 'Passou do limite de empresas do plano? Cada empresa extra custa um valor fixo por mês, sem precisar trocar de plano.'
            : 'O limite de investimento é só uma referência: se passar, avisamos e sugerimos o plano certo, sem bloquear seus anúncios.'}
        </p>
      </Section>
      <Section alt>
        <div className="sh-split">
          <div>
            <Words className="sh-display sh-h2" text="Dúvidas sobre *preço.*" />
            <div className="sh-note"><ShieldCheck size={18} aria-hidden /><span>O dinheiro dos anúncios não passa por nós. Você paga direto às plataformas; o Seu Impulso cobra só a assinatura.</span></div>
          </div>
          <Faq items={[
            ['Como funciona o teste grátis?', 'São 14 dias com tudo do plano Crescimento (ou Agência Start), sem cartão. No fim, você escolhe o plano.'],
            ['Quais formas de pagamento?', 'Pix, boleto ou cartão de crédito, com nota fiscal de serviço.'],
            ['Posso trocar de plano?', 'Sim, a qualquer momento, na tela de plano. A diferença é ajustada na próxima cobrança.'],
            ['Tem multa para cancelar?', 'Não. Se você já pagou o mês, continua usando até o fim do período.'],
            ['O que acontece se o pagamento atrasar?', 'Avisamos por e-mail. Depois de 7 dias a conta fica só para leitura e o piloto automático é pausado (nada é alterado nas suas campanhas). Após 30 dias, a conta é suspensa.'],
          ]} />
        </div>
      </Section>
      <Section id="contato">
        <div className="sh-split">
          <div>
            <Words className="sh-display sh-h2" text="Precisa de um plano *sob medida?*" />
            <p className="sh-p">Agências com muitos clientes, redes e franquias: conte o seu caso.</p>
          </div>
          <div className="card"><LeadForm kind={kind} /></div>
        </div>
      </Section>
      <FinalCta />
    </div>
  )
}
